import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../../utils/axios";

export const fetchTalentData = createAsyncThunk(
  "talentData/fetchTalentData",
  async ({ from, size, range }) => {
    const response = await axiosInstance.request({
      url: `explore/Talent?from=${from}&size=${size}${
        range ? `&gte=${range.gte}&lte=${range.lte}` : ""
      }`,
      method: "GET",
    });
    return response.data;
  },
);

export const fetchFilteredTalentData = createAsyncThunk(
  "talentData/fetchFilteredTalentData",
  async ({ from, size, range, body }) => {
    const response = await axiosInstance.request({
      url: `explore/talent?from=${from}&size=${size}${range ? range : ""}`,
      method: "POST",
      data: body,
    });
    return response.data;
  },
);

const talentSlice = createSlice({
  name: "talentData",
  initialState: {
    data: [],
    total: 0,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTalentData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTalentData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(fetchTalentData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchFilteredTalentData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFilteredTalentData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(fetchFilteredTalentData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default talentSlice.reducer;
